// tslint:disable-next-line: max-line-length
const allowedOrigins = [
  'http://133.40.210.127',
  'http://localhost:8080',
  'http://localhost:8888',
  'http://niu.mtk.nao.ac.jp:18888',
  'https://hscpfs.mtk.nao.ac.jp',
  'https://niu.mtk.nao.ac.jp',
  'https://hscmap.mtk.nao.ac.jp',
  'https://adc-sp.mtk.nao.ac.jp',
]

export function safeOrigin(ev: MessageEvent) {
  if (allowedOrigins.indexOf(ev.origin) >= 0) {
    return 1
  }
  if (confirm(`Do you allow ${ev.origin} to control hscMap?`)) {
    allowedOrigins.push(ev.origin)
    return true
  }
  alert(`Insecure host: ${ev.origin}`)
  return false
}
